import { render } from "./CardCreateFormasan.vue?vue&type=template&id=113233e0"
import script from "./CardCreateFormasan.vue?vue&type=script&lang=js"
export * from "./CardCreateFormasan.vue?vue&type=script&lang=js"

import "./CardCreateFormasan.vue?vue&type=style&index=0&id=113233e0&lang=css"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__